var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_66896",
    "data-name": "Group 66896",
    transform: "translate(7.933 -10)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2378",
    "data-name": "Ellipse 2378",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(-7.933 10)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "price-tag",
    transform: "translate(0.067 17.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66895",
    "data-name": "Group 66895",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79249",
    "data-name": "Path 79249",
    d: "M14.667,0H9.125A1.857,1.857,0,0,0,7.987.473l-7.6,7.6a1.337,1.337,0,0,0,0,1.885l5.657,5.657a1.336,1.336,0,0,0,1.885,0l7.6-7.6A1.858,1.858,0,0,0,16,6.878V1.335A1.338,1.338,0,0,0,14.667,0ZM12,5.335A1.333,1.333,0,1,1,13.334,4,1.334,1.334,0,0,1,12,5.335Z",
    transform: "translate(0 -0.002)",
    fill: "#929292"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIcon);
export default __webpack_public_path__ + "static/media/tagIcon.f7618d162c746398ad3b4effd2ab7621.svg";
export { ForwardRef as ReactComponent };